// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","piscar":"Footer_piscar__O2ol9"};